import React, { useEffect } from "react";
import { Card, Row, Col, Skeleton, Alert } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  MedicineBoxOutlined,
  BankOutlined,
  DollarOutlined,
  // CrownOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboard } from "../../Redux/Slice/Admin/Org";

const Dashboard = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  const { dashboardLoading, dashboardError, dashboardData } = useSelector(
    (state) => state.org
  );

  useEffect(() => {
    if (userId) {
      dispatch(fetchDashboard(userId));
    }
  }, [dispatch, userId]);

  const data = dashboardData?.data || {};

  if (dashboardError) {
    return (
      <div className="p-4">
        <Alert
          message="Error"
          description={dashboardError}
          type="error"
          showIcon
        />
      </div>
    );
  }

  // Common style for stat cards
  const statCardStyle = {
    borderRadius: 12,
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    padding: "16px",
    minHeight: 120,
  };

  const iconBoxStyle = (bg) => ({
    fontSize: 28,
    padding: 12,
    borderRadius: 12,
    marginRight: 16,
    color: "#fff",
    background: bg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  const stats = [
    // {
    //   title: "Total Doctors",
    //   value: data.totalDoctors ?? 0,
    //   icon: <UserOutlined />,
    //   color: "#1677ff",
    // },
    {
      title: "Total Branches",
      value: data.totalBranches ?? 0,
      icon: <BankOutlined />,
      color: "#52c41a",
    },
    {
      title: "Specialities",
      value: data.totalSpecialities ?? 0,
      icon: <MedicineBoxOutlined />,
      color: "#fa8c16",
    },
    {
      title: "Patients",
      value: data.totalPatients ?? 0,
      icon: <TeamOutlined />,
      color: "#13c2c2",
    },
    {
      title: "Admins",
      value: data.totalAdmins ?? 0,
      icon: <SolutionOutlined />,
      color: "#722ed1",
    },
    // {
    //   title: "Super Admins",
    //   value: data.totalSuperAdmins ?? 0,
    //   icon: <CrownOutlined />,
    //   color: "#eb2f96",
    // },
    {
      title: "Doctor Users",
      value: data.totalDoctorsUsers ?? 0,
      icon: <UserOutlined />,
      color: "#2f54eb",
    },
    {
      title: "Revenue",
      value: `₹${data.revenue?.toFixed(2) ?? "0.00"}`,
      icon: <DollarOutlined />,
      color: "#f5222d",
    },
  ];

  return (
    <div className="p-4">
      <Row gutter={[16, 16]}>
        {stats.map((item, index) => (
          <Col xs={24} sm={12} md={8} lg={6} key={index}>
            <Card style={statCardStyle} bordered={false}>
              <div style={iconBoxStyle(item.color)}>{item.icon}</div>
              <div>
                <Skeleton loading={dashboardLoading} active paragraph={false}>
                  <h2 style={{ margin: 0 }}>{item.value}</h2>
                  <p style={{ margin: 0, color: "#666" }}>{item.title}</p>
                </Skeleton>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Dashboard;
